"use client";

// الوضع الفاتح/الداكن (2026-10-06): المدير يحدّد الافتراضيّ والسماح بالداكن (المظهر والألوان ←
// `darkMode.default/enabled`)، والمستخدم يبدّل لنفسه بزرّ بجانب «تسجيل الخروج». اختيار المستخدم
// يُعلَّم في متصفّحه (`mc_mode_chosen`) فلا يطغى عليه الافتراضيّ؛ والداكن المعطَّل يفرض الفاتح للجميع.
import { useEffect } from "react";
import { useTheme as useNextTheme } from "next-themes";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "./useTheme";

const CHOSEN = "mc_mode_chosen";

export function useModeSwitch() {
  const { settings, loading } = useTheme();
  const { resolvedTheme, setTheme } = useNextTheme();
  const allowed = settings?.darkMode?.enabled !== false;
  const toggle = () => {
    try { localStorage.setItem(CHOSEN, "1"); } catch { /* private mode */ }
    setTheme(resolvedTheme === "dark" ? "light" : "dark");
  };
  return { allowed: allowed && !loading, dark: resolvedTheme === "dark", toggle };
}

/** يطبّق افتراضيّ المدير على من لم يختر بنفسه (يُركَّب مرّة في providers). */
export function ModeDefault() {
  const { settings, loading } = useTheme();
  const { setTheme } = useNextTheme();
  useEffect(() => {
    if (loading) return;
    const dm = settings?.darkMode;
    if (dm?.enabled === false) { setTheme("light"); return; }
    let chosen = false;
    try { chosen = localStorage.getItem(CHOSEN) === "1"; } catch { /* private mode */ }
    if (!chosen && dm?.default) setTheme(dm.default);
  }, [loading, settings?.darkMode?.enabled, settings?.darkMode?.default, setTheme]);
  return null;
}

/** زرّ المستخدم في الشريط العلويّ. */
export function ModeToggle() {
  const { allowed, dark, toggle } = useModeSwitch();
  if (!allowed) return null;
  return (
    <button type="button" onClick={toggle} aria-label={dark ? "الوضع الفاتح" : "الوضع الداكن"} title={dark ? "الوضع الفاتح" : "الوضع الداكن"}
      className="inline-flex size-9 items-center justify-center rounded-xl border border-th-border bg-th-surface text-th-text hover:bg-th-surface-alt">
      {dark ? <Sun className="size-4" /> : <Moon className="size-4" />}
    </button>
  );
}
